import { render, staticRenderFns } from "./StatisticsRegion.vue?vue&type=template&id=6055179d&scoped=true&"
import script from "./StatisticsRegion.vue?vue&type=script&lang=js&"
export * from "./StatisticsRegion.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsRegion.vue?vue&type=style&index=0&id=6055179d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055179d",
  null
  
)

export default component.exports